// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__OVhcg","left":"Mid_left__smZGt","right":"Mid_right__OlZlp","rightLine":"Mid_rightLine__Q0Q1s"};